import { useContext, useEffect, useRef, useState } from "react";
import ErrorView from "./../../../Component/ErrorView/ErrorView";
import BrandSpecItem from "./../BrandSpecItem/BrandSpecItem";
import { DiscoveryContext } from "./../discovery-context";
import classes from "./BrandThemes.module.css";

let failedLLMIndexes = [];

const THEMES = [
  // {
  //   id: 1,
  //   name: "GPT-4o",
  //   llm: "gpt-4o",
  //   url: "/llm-execute",
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  // },

  {
    id: 2,
    name: "GPT-5",
    llm: "gpt-5",
    url: "/llm-execute",
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
  },
  {
    id: 3,
    name: "Gemini",
    llm: "GeminiV25",
    url: "/llm-execute",
    img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
    text: "",
  },
  {
    id: 4,
    name: "Claude",
    llm: "Claude4",
    url: "/llm-execute",
    img: "https://claude.ai/images/claude_app_icon.png",
    text: "",
  },
  {
    id: 5,
    name: "Llama",
    llm: "llama3",
    url: "/llm-execute",
    img: "https://static.xx.fbcdn.net/rsrc.php/y5/r/m4nf26cLQxS.ico",
    text: "",
  },
  {
    id: 5,
    name: "Perplexity (sonar)",
    llm: "Perplexity",
    url: "/llm-execute",
    img: "https://mintlify.s3-us-west-1.amazonaws.com/perplexity/_generated/favicon/favicon-32x32.png?v=3",
    text: "",
  },
];

export default function BrandThemes({ entity, category, llm }) {
  const [error, setError] = useState();
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (discoveryCtx?.brand_snippets[llm][category].length > 0) return;

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [discoveryCtx?.brand_snippets[llm][category]?.length]);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);


let brandSnippets = [...THEMES].filter((_, i) => !failedLLMIndexes.includes(i));
let brand_snippets =  discoveryCtx?.brand_snippets[llm][category];

let loading = true;

if (brand_snippets && brand_snippets.length > 0) {
  brand_snippets.forEach((item, index) => {

    let llm = null;
    let dataList = [];

    if (item && typeof item === "object" && !Array.isArray(item)) {
      llm = item.llm ?? null;
      dataList = Array.isArray(item.data) ? item.data : [];
    }

    else if (Array.isArray(item)) {
      dataList = Array.isArray(item[0]) ? item[0] : item;
    }

    let snippet = null;

    if (llm) {
      snippet = brandSnippets.find((s) => s.llm === llm);
    } else {
      snippet = brandSnippets[index];
    }

    if (snippet && dataList.length > 0) {
      snippet.text = dataList
        .map((txt) => txt.charAt(0).toUpperCase() + txt.slice(1))
        .join(", ");
    }
  });

  loading = false;
}

  return (
    <div className={classes.container}>
      {brandSnippets.length > 0 && !error && (
        <BrandSpecItem
          loading={loading}
          data={brandSnippets}
          title={discoveryType === "brand" ? "Brand Themes" : "Product Themes"}
        />
      )}
      {error && (
        <ErrorView
          title="Error fetching brand themes"
          message={error}
          retry
        // onRetry={() => getBrandThemes()}
        />
      )}
    </div>
  );
}
